import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import ItemViewInList from '../../inventory/includes/ItemViewInList';
import NumberFormatter from '../../../services/NumberFormater';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import DateService from '../../../services/DateService';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TapIcon from '../../../services/TapIcon';
import SalesOrderDocumentModal from './SalesOrderDocumentModal';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { Modal } from 'bootstrap';
import uuid from 'react-uuid';
import HistoryDataModal from '../../inventory/HistoryDataModal'
class SalesOrderDetail extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            detail_loading: false,
            salesOrderDetail: null,
            salesTransactionID: null,
            itemView: "amount",
            interchangeItemData: null,
            interchangeableItemList: [],
            interchangeable_loading: false,
            saveInterchangeableItemForm: false,
            interchangeItemForm: { notes: '' },

        };
        this.interchangeItemModalId = uuid();
        this.salesOrderDetailUrl = INVENTORY_API_BASE_URL_2 + '/sales_order/detail';
        this.salesOrderUrl = INVENTORY_API_BASE_URL_2 + '/sales_order';
        this.salesOrderItemChangeUrl = this.salesOrderUrl + '/item_change';
        this.salesOrderItemChangeAltUrl = INVENTORY_API_BASE_URL_2 + '/sales_order_item_change';
        this.soDocDeleteUrl = INVENTORY_API_BASE_URL_2 + '/sales_order/doc_delete/doc_id';
        this.itemDetailsRef = React.createRef();
        this.documentRef                =   React.createRef();
        this.HistoryRef                 =   React.createRef();
        this.interchangebleItemModal = null;

    }

    componentDidMount() {

        if (this.props && this.props.salesID) {
            this.getQuotationDetail(this.props.salesID)
        }
        if (this.props && this.props.salesOrderDetail) {
            this.setState({ salesOrderDetail: this.props.salesOrderDetail })
        }

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.salesID !== this.props.salesID) {
            this.getQuotationDetail(nextProps.salesID)
        }
        if (nextProps.salesOrderDetail !== this.props.salesOrderDetail) {
            this.setState({ salesOrderDetail: nextProps.salesOrderDetail })
        }

    }

    getQuotationDetail = (transaction_id) => {
        this.setState({ detail_loading: true })
        HttpAPICall.withAthorization('GET', this.salesOrderDetailUrl + '/' + transaction_id, this.props.access_token, {need_comments:'Y',change_status_list: 'Y'}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                salesOrderDetail: respData,
                salesTransactionID: respData.transaction_id,
            });

        }).then(() => this.setState({ detail_loading: false }));
    }

    viewItemModalInit = (item) => {
        if (item) {
            this.itemDetailsRef.current.modalInit(item)
        }
    }

    formatAddress(address) {
        return <>
            {address && <Ax>
                {address.address1 ? address.address1 + ", " : ""}  {address.address2 ? address.address2 + ", " : ""}
                {address.landmark ? address.landmark + ", " : ""} {address.city ? address.city + ". " : ""}<br />
                Location : <b>{address.state_name ? address.state_name + ", " : ""}  {address.district_name ? address.district_name + "& " : ""}  {address.pincode ? address.pincode + "." : ""} <br /></b>
                GSTIN   :   <b>{address.gstin ? address.gstin : "-"}</b>
            </Ax>}
        </>
    }

    handleDocumentModal  =   ()  =>  {
        this.documentRef.current.showModalInit();
    }

    viewHistoryModalInit = (data, defaultAction = 'pr_history', extraParams = {}) => {

        if (this.state.salesOrderDetail && data) {
            let salesOrderDetail = this.state.salesOrderDetail;
            this.HistoryRef.current.modalHistoryInit(data, {
                defaultAction: defaultAction,
                historyTypes: [
                    { value: 'pr_history', label: 'PR History' },
                ]
            });
        }
    }

    viewInterchangeableModalInit = (itemdata) => {
        if (!itemdata?.item_profile) {
            return;
        }

        this.setState({
            interchangeItemData: {
                ...itemdata,
                transaction_id: this.state.salesOrderDetail?.transaction_id
            },
            interchangeItemForm: { notes: '' },
            interchangeableItemList: [],
            interchangeable_loading: true
        }, () => {
            this.getInterChangeableItemList(itemdata.item_profile.id, () => {
                this.showInterchangeModal();
            });
        });
    }

    getInterChangeableItemList = (id, callback = null) => {
        this.setState({ interchangeable_loading: true });
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/item/interchangeable_item/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                interchangeableItemList: respData.data || [],
            }, () => {
                if (callback) {
                    callback();
                }
            });
        }).then(() => this.setState({ interchangeable_loading: false }));
    }

    showInterchangeModal = () => {
        const modalElement = document.getElementById(this.interchangeItemModalId);
        if (modalElement) {
            if (this.interchangebleItemModal) {
                this.interchangebleItemModal.dispose();
            }
            this.interchangebleItemModal = new Modal(modalElement, { keyboard: false, backdrop: false });
            this.interchangebleItemModal.show();
        }
    }

    checkAllInterchangeList = () => {
        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        const allChecked = document.getElementById('all_check_interchange')?.checked || false;
        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                interchangeItemCheckboxCollections[i].checked = allChecked;
            }
        }
    }

    submitInterchangeRequest = (url, frmData) => {
        return HttpAPICall.withAthorization('PUT', url, this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            if (this.interchangebleItemModal) {
                this.interchangebleItemModal.hide();
            }
            this.getQuotationDetail(frmData.transaction_id || this.state.salesTransactionID);
        });
    }

    submitSelectedInterchangeItem = (e) => {
        e.preventDefault();

        let data = this.state.interchangeItemData;
        if (!data) {
            toast.error('No item data found', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        let allSelectedItems = [];
        let totalQty = 0;

        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                if (interchangeItemCheckboxCollections[i].checked) {
                    let item_id = interchangeItemCheckboxCollections[i].value;
                    let qtyInput = interchangeItemCheckboxCollections[i].closest('tr').querySelector('input[name="new_qty"]');
                    let qty = qtyInput ? qtyInput.value : interchangeItemCheckboxCollections[i].getAttribute('data-qty');
                    allSelectedItems.push({ item_id: item_id, qty: qty });
                    totalQty += parseFloat(qty) || 0;
                }
            }
        }

        const pendingQty = parseFloat(data.pending_qty || 0);

        if (allSelectedItems.length === 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (allSelectedItems.some(i => parseFloat(i.qty) <= 0)) {
            toast.error('Every Item\'s qty must be more than 0.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (allSelectedItems.some(i => i.qty === '' || i.qty === null)) {
            toast.error('Every Item\'s qty should not be blank', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (totalQty > pendingQty) {
            toast.error('Total Qty cannot be more than pending Qty', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        let frmData = {
            so_item_id: data.so_item_id || data.id,
            sales_order_item_id: data.so_item_id || data.id,
            transaction_id: data.transaction_id || this.state.salesTransactionID,
            item_id: data.item_profile?.id || data.item_id,
            replace_items: allSelectedItems,
            notes: this.state.interchangeItemForm.notes || ''
        };

        this.setState({ saveInterchangeableItemForm: true });
        this.submitInterchangeRequest(this.salesOrderItemChangeUrl, frmData)
            .catch((error) => {
                const statusCode = error?.response?.status;
                if (statusCode === 404 || statusCode === 405) {
                    return this.submitInterchangeRequest(this.salesOrderItemChangeAltUrl, frmData);
                }
                throw error;
            })
            .catch(() => {
                toast.error('Unable to interchange item', { position: toast.POSITION.TOP_RIGHT });
            })
            .finally(() => {
                this.setState({ saveInterchangeableItemForm: false });
            });
    }

    viewInterchangeableItemJsx = () => {
        const data = this.state.interchangeItemData;
        const max_qty = data?.pending_qty || 0;

        return (
            <div className="modal fade" id={this.interchangeItemModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Interchange Item</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>

                        {data && (
                            <div className='p-1 bg-light border-bottom'>
                                <table className='table table-sm mb-0 table-borderless text-sm'>
                                    <tbody>
                                        <tr>
                                            <td>Sales Order ID</td>
                                            <th>{data.transaction_id || this.state.salesTransactionID}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '26%' }}>Item Name</td>
                                            <th>{data.item_profile?.name || ''}</th>
                                        </tr>
                                        <tr>
                                            <td>Item Code</td>
                                            <th>{data.item_profile?.item_code || '-'}</th>
                                        </tr>
                                        <tr>
                                            <td>Order Qty</td>
                                            <th>{data.qty || '-'}</th>
                                        </tr>
                                        <tr>
                                            <td>Pending Qty</td>
                                            <th>{data.pending_qty || '0'}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="modal-body">
                            <form className="bg-white" onSubmit={this.submitSelectedInterchangeItem} id="salesOrderInterchangeItemForm" method="post" encType="multipart/form-data">
                                <table className="table table-hover table-bordered table-responsive bg-white my-3 table-sm">
                                    <thead className="table-secondary">
                                        <tr className="text-center">
                                            <th style={{ width: '7%' }}>
                                                <input type='checkbox' onChange={this.checkAllInterchangeList} id="all_check_interchange" />
                                            </th>
                                            <th className="text-start">Item Details</th>
                                            <th style={{ width: '13%' }} className="text-end">Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.interchangeable_loading
                                            ? (<tr><td colSpan="6"><Loader /></td></tr>)
                                            : (this.state.interchangeableItemList.length > 0
                                                ? (this.state.interchangeableItemList.map((item, k) => {
                                                    return (
                                                        <tr key={k} className="text-center">
                                                            <td>
                                                                <input type='checkbox'
                                                                    className="interchange_id_checkbox"
                                                                    name="interchangebleItem"
                                                                    value={item.id}
                                                                    data-qty={item?.new_qty || 0}
                                                                />
                                                            </td>
                                                            <td className="text-start">
                                                                <Ax>
                                                                    <b>{item.name}</b> <br />
                                                                    <small>Code: <b>{item.item_code}</b></small> <br />
                                                                    <small>Mfr: <b>{item.manufacturer?.name ?? '-'}</b> (MPN: <b>{item.manufacturer_part_no ?? '-'}</b>)</small>
                                                                </Ax>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className='form-control form-control-sm text-end'
                                                                    placeholder='Quantity'
                                                                    name="new_qty"
                                                                    type="number"
                                                                    value={item.new_qty || 0}
                                                                    onChange={(e) => {
                                                                        this.state.interchangeableItemList[k] = { ...item, new_qty: e.target.value };
                                                                        this.dynamicInputHandlerByKeyNameVal(e.target.value, 'new_qty', k, 'interchangeableItemList');
                                                                    }}
                                                                    max={max_qty}
                                                                    autoComplete="off"
                                                                    step=".01"
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                }))
                                                : (<tr><td colSpan="6" className="text-center">No Records</td></tr>)
                                            )
                                        }
                                    </tbody>
                                </table>

                                <div className="row align-items-center">
                                    <div className="col-sm-6">
                                        <label htmlFor="notes" className="form-label">Notes</label>
                                        <div>
                                            <textarea
                                                name="notes"
                                                value={this.state.interchangeItemForm.notes}
                                                onChange={(e) => this.formInputHandler(e, 'interchangeItemForm')}
                                                className="form-control"
                                                autoComplete='off'
                                                style={{ height: '100px' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="modal-footer">
                            <button type="submit" disabled={this.state.saveInterchangeableItemForm} className="btn btn-primary" form="salesOrderInterchangeItemForm">
                                Submit {this.state.saveInterchangeableItemForm ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    deleteSODocument   =   (doc_id)  =>  {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', this.soDocDeleteUrl.replace('doc_id', doc_id), this.props.access_token, {},{} ,(response) => {
                    toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    this.getQuotationDetail(this.state.salesOrderDetail.transaction_id);
                }).then(() => { });
            }
        });
    }

    allocationForData       =   (item) => {

        let type = '', name = '';
        if(!item) {
            return { type, name};
        }
        
        if(item.so_for == 'asset') {
            type    =   'Asset';
            name    =   `${item.asset.name} (${item.asset.asset_code})`;
        } else if(item.so_for == 'workstation') {
            type    =   'Workstation'; 
            name    =   item.workstation?.workstation_name;
        } else if(item.so_for == 'sub_assembly') {
            type    =   'Sub Assembly';
            name    =   item.sub_assembly?.name;
        } else if(item.so_for == 'employee') {
            type    =   'Employee';
            name    =   item.employee?.display_full_name;
        } 
        return { type, name}
    }

    reqDetailJsx = () => {
        let sales = this.state.salesOrderDetail;
        let purchase_summary = [];
        if (sales && sales.customerAddress && sales.customerAddress.state_id == sales.warehouse_state_id) {

            purchase_summary.push({ key: 'CGST ', value: "As applicable" });
            purchase_summary.push({ key: 'SGST ', value: "As applicable" });
        } else {
            purchase_summary.push({ key: 'IGST ', value: "As applicable" });
        }

        let sub_total_amount = sales && sales.items && sales.items.length > 0 && sales.items.map(s => s.item_rate_with_discount).reduce((a, b) => a + b, 0);

        let tcs_amount = sales && Number(sales.tcs_rate_vc && sales.tcs_rate_vc >= 0
            ? sales && sales.tcs_type == "Percentage" ? (sub_total_amount * sales.tcs_rate_vc / 100) : Number(sales.tcs_rate_vc)
            : 0);
        return (<Ax>

            {this.state.detail_loading ? <Loader />
                : <div className="modal-body ">
                    {this.state.salesOrderDetail
                        ? <div>
                            <table className="table table-bordered bg-white" >
                                <thead className="table-secondary">
                                    <tr>
                                        <th style={{ width: "33%" }}>ID</th>
                                        <th style={{ width: "33%" }}>Date</th>
                                        <th style={{ width: "33%" }}>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td scope="col">{sales.transaction_id}</td>
                                        <td scope="col">{DateService.dateTimeFormat(sales.transaction_date, 'DD-MMM-YYYY')}</td>
                                        <td scope="col" className="align-middle">
                                            {sales.status ? sales.status.name : ''}
                                        </td>  </tr>
                                </tbody>
                            </table>
                            <table className="table table-hover table-bordered  table-responsive bg-white mb-0">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "33%" }} >Sales Order Type</td>
                                        <td colSpan={2}>{sales.sales_order_type_name ? sales.sales_order_type_name : ""}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Warehouse</td>
                                        <td colSpan={2}>{sales.warehouse ? <div><b>{sales.warehouse.name} ({sales.warehouse.code})</b> <br />
                                            {sales.warehouse_address ?
                                                <div className='pt-1'>Address : {sales.warehouse_address.address1 ? sales.warehouse_address.address1 + ", " : ""}
                                                    {sales.warehouse_address.address2 ? sales.warehouse_address.address2 + ", " : ""}
                                                    {sales.warehouse_address.landmark ? sales.warehouse_address.landmark + ", " : ""}
                                                    {sales.warehouse_address.city ? sales.warehouse_address.city + ". " : "-"} <br />
                                                    Location : <b>{sales.warehouse_address.state_name}</b> <br />
                                                    GSTIN  : {sales.warehouse_address.gstin ? sales.warehouse_address.gstin : "-"} <br />
                                                </div> : "-"}</div> : "-"} <br />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} >Customer</td>
                                        <td colSpan={2} >{sales.customer ? <div>{sales.customer.name} ({sales.customer.code}) <br />
                                            {(sales.customerAddress || sales.customerProject) &&
                                                <div className='py-1'>
                                                    Project : {sales.customerProject ? <span><b>{sales.customerProject.project_name} ({sales.customerProject.project_code}) </b></span> : "-"} <br />

                                                    {/* Address :  {sales.customerProject ? this.formatAddress(sales.customerProject ) : this.formatAddress(sales.customerAddress)}  */}
                                                </div>}

                                        </div> : "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "33%" }} ></td>

                                        <td>
                                            <div><b>Bill To Address</b></div>
                                            {sales.customerProject ? this.formatAddress(sales.customerProject.address) : sales.customer_billing_address ? this.formatAddress(sales.customer_billing_address) : ""}
                                            <br />
                                        </td>

                                        <td>
                                            <div><b>Ship To Address</b></div>
                                            {sales.customerProject ? this.formatAddress(sales.customerProject.address) : sales.customer_shipping_address ? this.formatAddress(sales.customer_shipping_address) : ""}                                            <br />
                                        </td>
                                    </tr>
                                     <tr>
                                    <td style={{ width: "33%" }} >Sales Order For</td>
                                    <th colSpan={2}>{this.allocationForData(sales).type}</th>
                                </tr>
                                {sales.so_for 
                                ?
                                    <tr>
                                        <td style={{ width: "33%" }} >
                                            {this.allocationForData(sales).type} 
                                        </td>
                                        <td colSpan={2}>
                                            {this.allocationForData(sales).name}
                                        </td>
                                    </tr> 
                                : null
                                }
                                    <tr>
                                        <td scope="col">Priority & Delivery Date</td>
                                        <td className="text-capitalize">{sales.priority ?? "-"}</td>
                                        <td>{sales.delivery_date ? DateService.dateTimeFormat(sales.delivery_date, 'DD-MMM-YYYY') : "-"}</td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Payment Terms</td>
                                        <td colSpan={sales.payment_terms && sales.payment_terms == "net_days" ? 1 : 2} className="text-capitalize">{sales.payment_terms ? sales.payment_terms == "advance" ? "Advance" : sales.payment_terms == "net_days" ? "Net Days" : "On Receipt of Invoice" : "-"}</td>
                                        {sales.payment_terms && sales.payment_terms == "net_days" && <td scope="col" style={{ width: "33%" }}  >{sales.net_days ? sales.net_days : ""}</td>}
                                    </tr>
                                    <tr>
                                        <td scope="col">PO Number & Date</td>
                                        <td className="text-capitalize">{sales.po_number ? sales.po_number : "-"}</td>
                                        <td scope="col" style={{ width: "33%" }}  >{sales.po_date ? DateService.dateTimeFormat(sales.po_date, 'DD-MMM-YYYY') : ""}</td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Deal</td>
                                        <td scope="col" >{sales && sales.deal_data ? sales.deal_data.header : ""}</td>
                                    </tr>
                                    <tr>
                                        <td scope="col">Tag Users</td>
                                        <td scope="col" colSpan={2}>{sales && sales.users && sales.users.length > 0 ? sales.users.map(u => <div>{u.full_name}</div>) : ""}</td>
                                    </tr>

                                    <tr>
                                        <td scope="col">Currency</td>
                                        <td colSpan={2}><b>{sales.currency}</b> {sales.currency !== sales.base_currency ? <span>(1 {sales?.currency} : <NumberFormatter number={sales?.conversion_rate} precision={2} /> {sales?.base_currency})</span> : null}</td>

                                    </tr>
                                    {sales.additional_attribute_data && sales.additional_attribute_data.length > 0
                                        ? sales.additional_attribute_data.map((attr) => {
                                            return (<tr key={attr.key}>
                                                <td scope="col" className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                                <td scope="col" colSpan={2}>{attr.value_display ? attr.value_display : "-"}</td>
                                            </tr>)
                                        }) : null}
                                </tbody>
                            </table>
                            <div className="my-3">
                                <label className="form-check-label me-3">Show Item : </label>
                                <input
                                    type="radio"
                                    name="itemView"
                                    value="amount"
                                    checked={this.state.itemView === 'amount'}
                                    onChange={() => {
                                        this.setState({ itemView: 'amount' })
                                    }}
                                /> Amount
                                <input
                                    type="radio"
                                    name="itemView"
                                    value="quantity"
                                    checked={this.state.itemView === 'quantity'}
                                    onChange={() => {
                                        this.setState({ itemView: 'quantity' });
                                    }}
                                    className="ms-3"
                                /> Quantity
                            </div>
                            {this.state.itemView == "amount" ? <table className="table table-bordered table-responsive bg-white my-3 table-sm" id="poTable">
                                <thead className="table-secondary">
                                    <tr>
                                        <th scope="col" style={{ width: "5%" }} className="text-center"><input type='checkbox' onChange={() => this.props.checkAllItem ? this.props.checkAllItem() : null} id="all_check_allocation" /></th>
                                        <th style={{ width: "39%" }}>Item Details</th>
                                        <th style={{ width: "12%" }} className="text-end">Quantity</th>
                                        <th style={{ width: "8%" }} className="text-end">Unit Rate</th>
                                        <th style={{ width: "8%" }} className="text-end">Discount</th>
                                        <th style={{ width: "8%" }} className="text-end">Tax</th>
                                        <th style={{ width: "8%" }} className="text-end">Amount</th>
                                        {/* <th style={{ width: "8%" }} className="text-center">Pending</th>*/}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sales && sales.items && sales.items.length > 0 ? sales.items?.map((i, k) => {
                                            return (<tr>
                                                <td className='text-center'>
                                                    {k + 1} <br /><br />
                                                    <input
                                                        type='checkbox'
                                                        name="foo"
                                                        value={i?.item_profile?.id}
                                                        data-pendingQty={i.pending_qty}
                                                        className="allocation_item_id_checkbox"
                                                        data-warehouseId={sales.warehouse_id}
                                                        data-purchaseQty={i?.purchase_qty ?? 0}
                                                        data-itemData={i?.item_profile}
                                                        data-transactionId={sales.transaction_id}
                                                        data-statusLevel={sales.status_data && sales.status_data.level}
                                                        data-statusIds={sales.status_data && sales.status_data.id}
                                                    />

                                                </td>

                                                <td>{i.item_profile ?
                                                    <div className='row'>
                                                        <div className='col-sm-10'>
                                                            <ItemViewInList view_hsn={true} item={i.item_profile} remark={i.remark} due_date={i.due_date_display} viewItemModal={() => this.viewItemModalInit(i.item_profile)} />
                                                        </div>
                                                        <div className='col-sm-2 text-end'>
                                                            <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                                                                <li className='dropdown-item' style={{ padding: "7px 5px" }} onClick={() => this.viewHistoryModalInit(i.item_profile)}>
                                                                    <button type="button" className='text-decoration-none btn btn-sm'>View History</button>
                                                                </li>
                                                                {this.props.permissions && this.props.permissions.includes('isc-item-Interchangeable-edit') ?
                                                                    <li className='dropdown-item' style={{ padding: "7px 5px" }} onClick={() => this.viewInterchangeableModalInit(i)}>
                                                                        <button type="button" className='text-decoration-none btn btn-sm'>Interchange Item</button>
                                                                    </li>
                                                                    : null}
                                                            </ul>
                                                        </div>

                                                    </div>
                                                    : null}</td>

                                                <td className='text-end'>{i.qty}
                                                    {i.item_profile.measuring_unit && i.item_profile.measuring_unit.name ? <span className="text-helping input-group-text text-end pr0">{i.item_profile?.measuring_unit?.name}</span> : null}

                                                </td>
                                                <td className='text-end'>{i.rate_vc}</td>
                                                <td className='text-end'>{i.discount_amount_vc ? <div>{i.discount_type == "Fixed" ? sales.currency : null} {i.discount_amount_vc} {i.discount_type == "Percentage" ? "%" : null}</div> : 0}</td>
                                                <td className='text-end'>{sales && sales.warehouse_address && sales.warehouse_address.gstin ? <div>{i.gst} %</div> : "NA"}
                                                    {sales && sales.warehouse_address && sales.warehouse_address.gstin && i.item ? <span className="text-helping input-group-text text-end pr0">{sales.customerAddress && sales.customerAddress.state_name == sales.warehouse_address.state_name ? "GST" : "IGST"}</span> : null}
                                                </td>
                                                <td className='text-end'>
                                                    <CurrencyFormatter currencyCode={sales.currency} amount={parseFloat(i.amount_with_discount_vc).toFixed(2)} />
                                                </td>
                                            </tr>)

                                        }) : <tr ><td className='text-center' colSpan={8}>No Record</td></tr>
                                    }
                                </tbody>
                            </table>
                                : <table className="table table-bordered table-responsive bg-white my-3 table-sm" id="poTable">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th scope="col" style={{ width: "5%" }} className="text-center">
                                                <input type='checkbox' onChange={() => this.props.checkAllItem ? this.props.checkAllItem() : null} id="all_check_allocation" />
                                            </th>
                                            <th style={{ width: "39%" }}>Item Details</th>
                                            <th style={{ width: "12%" }} className="text-end">Order Qty</th>
                                            <th style={{ width: "8%" }} className="text-end">Allocated</th>
                                            <th style={{ width: "8%" }} className="text-end">Invoiced</th>
                                            <th style={{ width: "8%" }} className="text-end">Cancelled</th>
                                            <th style={{ width: "8%" }} className="text-end">Pending</th>
                                            {/* <th style={{ width: "8%" }} className="text-center">Pending</th>*/}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sales && sales.items && sales.items.length > 0 ? sales.items?.map((i, k) => {
                                                return (<tr>
                                                    <td className='text-center'>
                                                        {k + 1} <br /><br />
                                                        <input
                                                            type='checkbox'
                                                            name="foo"
                                                            value={i?.item_profile?.id}
                                                            data-pendingQty={i.pending_qty}
                                                            className="allocation_item_id_checkbox"
                                                            data-warehouseId={sales.warehouse_id}
                                                            data-purchaseQty={i?.purchase_qty ?? 0}
                                                            data-itemData={i?.item_profile}
                                                            data-transactionId={sales.transaction_id}
                                                            data-statusLevel={sales.status_data && sales.status_data.level}
                                                            data-statusIds={sales.status_data && sales.status_data.id}
                                                        />
                                                    </td>

                                                    <td>{i.item_profile ?
                                                        <div className='row'>
                                                            <div className='col-sm-10'>
                                                                <ItemViewInList view_hsn={true} item={i.item_profile} remark={i.remark} due_date={i.due_date_display} viewItemModal={() => this.viewItemModalInit(i.item_profile)} />
                                                            </div>
                                                            <div className='col-sm-2 text-end'>
                                                                <TapIcon.imageIcon icon={TapIcon.ListActionIcon} alt="action-icon" className="img-fluid" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1" >
                                                                    <li className='dropdown-item' style={{ padding: "7px 5px" }} onClick={() => this.viewHistoryModalInit(i.item_profile)}>
                                                                        <button type="button" className='text-decoration-none btn btn-sm'>View History</button>
                                                                    </li>
                                                                    {this.props.permissions && this.props.permissions.includes('isc-item-Interchangeable-edit') ?
                                                                        <li className='dropdown-item' style={{ padding: "7px 5px" }} onClick={() => this.viewInterchangeableModalInit(i)}>
                                                                            <button type="button" className='text-decoration-none btn btn-sm'>Interchange Item</button>
                                                                        </li>
                                                                        : null}
                                                                </ul>
                                                            </div>

                                                        </div>
                                                        : null}</td>

                                                    <td className='text-end'>{i.qty ?? "0"}</td>
                                                    <td className='text-end'>{i.allocated_qty ?? "0"}</td>
                                                    <td className='text-end'>{i.invoiced_qty ?? "0"}</td>
                                                    <td className='text-end'>{i.cancelled_qty ?? "0"}</td>
                                                    <td className='text-end'>{i.pending_qty ?? "0"}</td>
                                                </tr>)

                                            }) : <tr ><td className='text-center' colSpan={7}>No Record</td></tr>
                                        }
                                    </tbody>
                                </table>}
                            <div className="row align-items-center mb-5">
                                <div className="col-6">
                                    <label htmlFor="notes" className="form-label">Notes</label>
                                    <div>{sales.notes ?? "-"}</div>

                                </div>
                                <div className="col-6">
                                    <table className="table  table-borderless">
                                        <tbody>
                                            <tr className="subtotal_bg_color">
                                                <th>Sub-Total ({sales.currency ? sales.currency : "INR"})</th>
                                                <td className='float-end'>{sales.sub_total_amount_vc ? sales.sub_total_amount_vc : 0}</td>
                                            </tr>
                                            {sales && sales.tcs_rate_vc && sales.tcs_rate_vc > 0 ? <tr className="subtotal_bg_color">
                                                <th>TCS ({sales.tcs_type == "Fixed" ? sales.currency : null} {sales.tcs_rate_vc} {sales.tcs_type == "Percentage" ? "%" : null} )</th>
                                                <td className='float-end'><NumberFormatter number={tcs_amount} precision={2} /></td>
                                            </tr> : null}
                                            {sales.tax_slabs && sales.tax_slabs.length > 0
                                                ? (sales.tax_slabs.map((ps, k) => {
                                                    return <tr className="subtotal_bg_color"><th>{ps.key}</th><td className="text-end">{ps.value}</td></tr>
                                                }))
                                                : null
                                            }

                                            <tr className="subtotal_bg_color">
                                                <th>Adjustment</th>
                                                <td className='float-end'>{sales.adjustment_amount_vc  ?? 0}</td>
                                            </tr>
                                            <tr className="subtotal_bg_color">
                                                <th>Final Total ({sales.currency ? sales.currency : "INR"})</th>
                                                <td className='float-end'>{sales.total_amount_vc ? <CurrencyFormatter currencyCode={sales.currency} amount={sales.total_amount_vc} /> : 0}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr/>
                            <div className="tab_content_wrapper mt-4">
                            <span className="content_heading">Document</span>
                            {
                            this.props.permissions.includes('sales_order_doc_add') &&
                                <span className="text-end dropdown">
                                <button type="button" onClick={() => this.handleDocumentModal()} className="btn btn-light">
                                <TapIcon.FontAwesomeIcon className="text-muted" icon={TapIcon.faPlus} />
                                </button>
                                </span>
                            }
                        </div>
                        <table className="table table-bordered bg-white my-2">
                            <tbody>
                            {
                                sales.docs && sales.docs.length > 0
                                ? sales.docs.map((d, i) => {
                                    return <tr key={i}>
                                        <td scope="col" style={{ width: "5%" }}>{i + 1}</td>
                                        <td  scope="col" style={{ width: "65%" }} className="text-capitalize">
                                                {d.name}
                                                {d.number && `(${d.number})`}
                                        </td>
                                        {d.longitude && d.latitue && (
                                            <td scope="col" style={{ width: "6%" }} className="text-center" >
                                            <Link to={`https://www.google.com/maps/search/${d.latitude},${d.longitude}`} target="_blank"><TapIcon.FontAwesomeIcon
                                                icon={TapIcon.faMapMarker}/>
                                            </Link>
                                            </td>
                                        )}
                                        <td scope="col" className="text-center" style={{ width: "6%" }} >
                                            <Link to={{pathname:  d.path }} target="_blank" 
                                            className={[this.props.permissions.includes('sales_order_doc_view') ? '' : 'disabled-link'].join(' ')}
                                            title={this.props.permissions.includes('sales_order_doc_view') ? '' : 'You do not have permission to perform this action'}
                                            style={{ "pointerEvents": "all" }}
                                            >
                                            <TapIcon.FontAwesomeIcon
                                                icon={TapIcon.faEye}
                                            />
                                            </Link>
                                        </td>
                                        <td scope="col" style={{ width: "6%" }} className="text-center">
                                            <Link to={{pathname : d.path}} target='_blank' 
                                            className={[this.props.permissions.includes('sales_order_doc_download') ? '' : 'disabled-link'].join(' ')}
                                            title={this.props.permissions.includes('sales_order_doc_download') ? '' : 'You do not have permission to perform this action'}
                                            style={{ "pointerEvents": "all" }}
                                            >
                                            <TapIcon.FontAwesomeIcon
                                                icon={TapIcon.faDownload}
                                            />
                                            </Link>
                                        </td>
                                        <td className="text-center" style={{ width: "6%" }}> 
                                            <Link 
                                            className={[this.props.permissions.includes('sales_order_doc_delete') ? '' : 'disabled-link'].join(' ')}
                                            style={{ "pointerEvents": "all" }}
                                            onClick={() => { this.props.permissions.includes('sales_order_doc_delete') && this.deleteSODocument(d.id)}}
                                            ><TapIcon.FontAwesomeIcon icon={TapIcon.faTrashAlt}
                                            className="asset_link"/></Link>
                                        </td>
                                    </tr>
                                })
                                : <tr><td className='text-center' colSpan="6">No Document Found</td></tr>
                            }
                            </tbody>
                        </table>
                            <div className="tab_content_wrapper content_heading">Terms & Condition</div>
                            <table className="table table-hover table-bordered bg-white my-3">
                                <thead className='table-secondary'>
                                    <tr>
                                        <th className='text-center' style={{ width: "10%" }}>S.No</th>
                                        <th className='text-start' style={{ width: "25%" }}>Name</th>
                                        <th className='text-start' style={{ width: "65%" }}>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        sales.tnc && sales.tnc.length > 0 ? sales.tnc.map((tc, k) => {
                                            return (<tr key={k}>
                                                <td className='text-center'>{k + 1}</td>
                                                <td>{tc.name}</td>
                                               <td dangerouslySetInnerHTML={{ __html: tc.text }} />
                                            </tr>);
                                        })
                                            : <tr ><td className='text-center' colSpan={3}>No Record</td></tr>
                                    }

                                </tbody>
                            </table>

                            <hr />

                        </div>
                        : null}
                </div>}
            <ItemDetailsModal ref={this.itemDetailsRef} />
            {this.viewInterchangeableItemJsx()}
        </Ax>)
    }


    render() {
        return (
            <div>
                {this.reqDetailJsx()}
                <SalesOrderDocumentModal ref={this.documentRef} salesOrderDetail={this.state.salesOrderDetail} getDetails={(id) => this.getQuotationDetail(id)} />
                <HistoryDataModal ref={this.HistoryRef} />
            </div>
        )

    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        isc_configuration: state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(SalesOrderDetail);